module.exports = __webpack_public_path__ + "media/ipx_subbrands.5b69c236.mp4";